import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import deTranslation from './locales/de/translation.json';
import enTranslation from './locales/en/translation.json';
import hrTranslation from './locales/hr/translation.json';

const resources = {
  en: { translation: enTranslation },
  hr: { translation: hrTranslation },
  de: { translation: deTranslation }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'hr', 'de'],
    // 'hr-HR' ili 'de-AT' → normalizira na 'hr' / 'de' prije provjere supportedLngs
    load: 'languageOnly',
    // Flat ključevi s točkama: "errors.timeout.title" je jedan ključ, ne hijerarhija
    keySeparator: false,
    interpolation: { escapeValue: false },
    detection: {
      // 1. ?lng= (dolazak s landing stranice) — pobjeđuje i sprema se u localStorage
      // 2. localStorage (eksplicitni odabir korisnika)
      // 3. navigator (browser jezik) — koristi se samo ako je u supportedLngs
      //    ako nije podržan, i18next automatski pada na fallbackLng ('en')
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lng',
      caches: ['localStorage']
    }
  });

// Makni ?lng iz URL-a nakon što je jezik spremljen, da ne ostane u adresi/bookmarku
const url = new URL(window.location.href);
if (url.searchParams.has('lng')) {
  url.searchParams.delete('lng');
  window.history.replaceState(window.history.state, '', url);
}

export default i18n;
